
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Confirm Dialog box
export const ConfirmDialog = ({ title, subtitle, onConfirm }) => {
  confirmAlert({
    overlayClassName: 'bg-black/20 backdrop-blur-sm',
    closeOnClickOutside: true,
    customUI: ({ onClose }) => {
      return (
        <div className="bg-white/90 rounded-2xl shadow-2xl p-6 max-w-md mx-auto text-center">
          <h2 className="text-xl font-semibold text-red-600 mb-2">{title}</h2>
          <p className="text-gray-700 mb-6">{subtitle}</p>
          <div className="flex justify-center gap-4">
            <button
              className="bg-gray-200 text-gray-800 hover:bg-gray-300 px-4 py-2 rounded-lg"
              onClick={onClose}
            >
              No
            </button>
            <button
              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        </div>
      );
    }
  });

  return null; 
};

// Tooltip 
export const Tooltip = ({ text }) => {
  return (
    <div className="absolute top-[-24px] -left-10 w-32 text-center p-2 bg-gray-700 text-white text-sm rounded-md shadow-lg z-50">
      {text}
    </div>
  );
};

// Toast helpers
export const showSuccessToast = (message) => {
    toast.success(message, {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light'
    });
};

export const showErrorToast = (message) => {
  toast.error(message, {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: 'light'
  });
};
  
// Export ToastContainer for use in root component
export { ToastContainer };